<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>

        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('Proforma.title')}}</strong>
                <div class="float-right">
                  <router-link :to="{ path: '/Proformas'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('Proformas.title')}}</router-link>
                  &nbsp;
                  <!--<span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('Proforma.new')}}</span>-->
                </div>
              </div>
              <div class="card-body card-block">
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">


                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="dt_needtransfer" class=" form-control-label">{{ $t('Proforma.dt_needtransfer') }} ({{ $t('validator.required')-->
                  <!--}})</label>-->
                  <!--</div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText type="DatetimepickerBp"-->
                  <!--id="dt_needtransfer" name="data.dt_needtransfer" v-model="data.dt_needtransfer" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:false}" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('Document.dt_needtransfer')"-->
                  <!--placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_needtransfer')"-->
                  <!--/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_transfer_2" class=" form-control-label">{{ $t('Proforma.dt_transfer') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_transfer_2" name="data.dt_transfer" v-model="data.dt_transfer" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:false}" hasToKeyboard="auto" value=""
                                 :title="$t('Document.dt_transfer')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_transfer')"

                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label class=" form-control-label">{{ $t('Proforma.transfered') }}</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <select id="transfered" v-model="data.transfered" class="form-control mandatory w100" name="transfered">
                        <option value="0">{{$t('global.no')}} </option>
                        <option value="1">{{$t('global.yes')}} </option>
                      </select>
                    </div>
                  </div>

                  <hr>

                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <template v-if="data && data.id">
                        <!--<template v-if="!hasAccountant">-->

                        <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'proforma'"
                                      :handlerSuccess="fileUploadHadler"></FileUploader>
                        <!--<template v-if="hasnav && !hasAccountant">-->
                        <!--<div v-if="images.length<1" class="alert alert-danger">-->
                        <!--{{ $t('InvoiceInbound.no_image_error') }}-->
                        <!--</div>-->
                        <!--</template>-->
                        <!--</template>-->
                      </template>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <div class="col col-12X">
                        <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'proforma'" :handlerSuccess="imageClickHadler"
                                        :cbDataChange="cbDataChange"></ImageDisplayer>
                      </div>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="identifier" class=" form-control-label">{{ $t('Proforma.identifier') }} ({{ $t('validator.required') }}) </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.identifier" type="text" id="identifier" placeholder="" class="form-control" name="data.identifier"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.identifier')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="title" class=" form-control-label">{{ $t('Proforma.ptitle') }} </label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<input v-model="data.title" type="text" id="title" placeholder="" class="form-control" name="data.title"-->
                  <!--v-validate="''" v-bind:class="{'is-invalid':errors.has('data.title')}">-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->


                  <div class="row form-group">
                    <div class="col-2">
                      <label class=" form-control-label"><span class="font-weight-bold">{{ $t('global.buyer') }}</span></label>
                    </div>

                    <div class="col-10 text-right">
                      <template v-if="data.wf_status_saved === 'UPLOADING'">
                        <button type="submit" class="btn btn-success btn-sm" v-on:click="copyCompanyDataToModel">
                          <i class="fa fa-paste"></i> {{$t('InvoiceInbound.pasteownbusinessdata')}}
                        </button>
                      </template>
                    </div>

                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="to_name" class=" form-control-label">{{ $t('businesspartner.businesspartnername') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText id="to_name" name="data.to_name" v-model="data.to_name" v-validate="'required'" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.businesspartnername')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.to_name')"/>
                      <small class="form-text text-muted"></small>
                      <!--<NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav && !justAccountant" :value="data.to_name" dataKey="to_name"-->
                      <!--:dataObjectStr="data.navdata"></NavDataDiffDisplayer>-->
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="to_taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>
                    <div class="col-12 col-md-9">
                      <table class="w100">
                        <tr>
                          <td class="w0 valigntop">
                            <template v-if="hasnav===true">
                              <div class="input-group topminus2px">
                                <div class="btn btn-primary" v-on:click="getQueryTaxpayer('to')"><i class="fa fa-eye-slash"></i></div>
                              </div>
                            </template>
                          </td>
                          <td class="w100">
                            <InputText
                              id="to_taxnumber" name="data.to_taxnumber" v-model="data.to_taxnumber" v-validate="" hasToKeyboard="auto" value=""
                              :title="$t('businesspartner.to_taxnumber')"
                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.to_taxnumber')"/>
                            <small class="form-text text-muted"></small>
                          </td>
                        </tr>
                      </table>
                      <!--<NavDataDiffDisplayer :fncb="fncb" defaultclass="alert alert-danger" v-if="hasnav && !justAccountant" :value="data.to_taxnumber" dataKey="to_taxnumber"-->
                      <!--:dataObjectStr="data.navdata"></NavDataDiffDisplayer>-->
                      <DataCheckerErrorDisplayer defaultclass="alert alert-danger" v-if="true" :value="data.to_taxnumber" :isMandatory="false"
                                                 :displayfn="displayfn_from_taxnumber" messageKey="global.taxnumberformaterror"></DataCheckerErrorDisplayer>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_make" class=" form-control-label">{{ $t('Document.dt_make') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_make" name="data.dt_make" v-model="data.dt_make" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Document.dt_make')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_make')"
                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label class=" form-control-label">{{ $t('Proforma.currency') }}</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <select id="currency" v-model="data.currency" class="form-control mandatory w100" name="currency"
                      >
                        <!--disabled="true"-->
                        <!--readonly="true"-->
                        <option value="">-</option>
                        <option value="HUF">HUF</option>
                        <option value="EUR">EUR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('Proforma.price_sum_net') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.price_sum_net" type="text" id="price_sum_net" placeholder="" class="form-control" name="data.price_sum_net"
                             v-validate="'numberprice|required'" v-bind:class="{'is-invalid':errors.has('data.price_sum_net')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="price_sum_gross" class=" form-control-label">{{ $t('Proforma.price_sum_gross') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.price_sum_gross" type="text" id="price_sum_gross" placeholder="" class="form-control" name="data.price_sum_gross"
                             v-validate="'numberprice'" v-bind:class="{'is-invalid':errors.has('data.price_sum_gross')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group     d-none d-xs-block d-sm-block d-md-block d-lg-block d-xl-block">

                    <div class="col col-4">
                      <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'proforma'"
                                      :handlerSuccess="imageClickHadler"></ImageDisplayer>
                    </div>
                    <div class="col col-8">

                      <div class="row">
                        <div class="col-12">

                          <div class="row form-group">
                            <div class="col col col-6"><label class=" form-control-label">{{ $t('global.fileupload') }}</label>
                            </div>
                            <div class="col col col-6">
                              <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'proforma'"
                                            :handlerSuccess="fileUploadHadler"></FileUploader>
                            </div>
                            <div class="col col-12">
                              <!--<ImageDisplayer classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'proforma'" :handlerSuccess="imageClickHadler"></ImageDisplayer>-->
                            </div>
                          </div>

                        </div>
                      </div>
                      <!--<div class="row">-->
                      <!--<div class="col-12">-->
                      <!--<span v-for="image in images" class="image">{{image}}</span>-->

                      <!--</div>-->
                      <!--</div>-->
                      <hr>

                    </div>
                  </div>


                </form>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary btn-sm" v-on:click="save()">
                  <i class="fa fa-dot-circle-o"></i> {{$t('global.save')}}
                </button>
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>
            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  import ImageDisplayer from '@/components/ImageDisplayer.vue';
  import FileUploader from '@/components/FileUploader.vue';
  import BusinessPartnerSearcher from '@/components/BusinessPartnerSearcher.vue';
  import NavDataDiffDisplayer from '@/components/NavDataDiffDisplayer.vue';
  import DataCheckerErrorDisplayer from '@/components/DataCheckerErrorDisplayer.vue';


  //  id_store 	wsid 	text
  export default {
    name: 'Proforma',
    data() {
      return {
        Helper: Helper
        , bank_accountObject: {bank_account: void 0}

        , data: {
          // cardinality 	Proforma_text 	deleted
          "id": "",
          "identifier": "",
          "title": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_sum_gross": "",
          "transfered": "",
          "dt_needtransfer": "",
          "dt_transfer": "",
          "payment_type": "",
        }
        , dataBase: { // need for change without save
          "id": "",
          "identifier": "",
          "title": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_sum_gross": "",
          "transfered": "",
          "dt_needtransfer": "",
          "dt_transfer": "",
          "payment_type": "",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }
        , breadcrumbstitle: 'Proforma.title'
        , breadcrumbsData: [
          {
            'title': "Proforma.title",
            'url': "Proforma",
          },
          {
            'title': "Proforma.title",
          }
        ]
        , images: []
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , hasnav: false
        , businesspartnersearcher: false

      };
    },
    props: {
      id: String,
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        if (this.$route.params.id) {
          this.id = newdata;
          this.getElement();
        } else {
          this.id = void 0;
        }
      },

      "data.from_taxnumber": function (newData, oldData) {
        const modul = this;
        console.log("watcher-data.from_taxnumber");
        if (newData !== oldData) {
          clearTimeout(modul.timer1);
          modul.timer1 = setTimeout(function () {
            console.log("Lekérés - getBusinessPartnerByTaxnumber")
            if (newData) {
              modul.getBusinessPartnerByTaxnumber();
            }
          }, 1000)
        }
      },

    },
    mounted() {
      const modul = this;
      modul.handleRights();
      modul.$eventBus.$on('globalSetBusinessPartner', this.globalSetBusinessPartnerEventHandler);
    },
    beforeDestroy() {
      this.$eventBus.$off('globalSetBusinessPartner');
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
        if (modul.state && modul.state.settings) {
          modul.hasnav = (modul.state.settings.hasnav === "true");
        }
        if (modul.state && modul.state.settings) {
//          modul.default_type = (modul.state.settings.default_type);
          modul.dataBase.currency = String(modul.state.settings.default_type).toLowerCase();
          modul.data.currency = String(modul.state.settings.default_type).toLowerCase();
        }
      },
      init(){
        const modul = this;
        modul.getElement();
      },
      cbDataChange(data){
        const modul = this;
        modul.images = data
        console.log("cbDataChange - data");
        console.log(data);
      },
      getElement(){
        const modul = this;
        let id = 0;
        try {
          id = (this.$route.params.id);
          if (id) {
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.getProforma({id: id, id_company: modul.state.id_company}).then(function (res) {
              console.log(res);
              if (res && res.result && res.data) {
                modul.data = res.data;
                modul.AlertInPage.msg = "";
              } else {
//                modul.data = Object.assign({}, modul.dataBase);
                modul.hasRole = false;
                modul.AlertInPage.msg = "form.error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
//                  modul.$router.push({path: "/proformas"})
                }, Number(2000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
        this.$router.push({name: "/proforma"})
      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const req = {};
            req.data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "identifier", "title", "dt_make", "price_sum_net", "price_sum_gross", "transfered", "dt_needtransfer", "dt_transfer", "payment_type", "to_name", "to_taxnumber", "currency"]);
            req.id_company = modul.state.id_company;
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.saveProforma(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                  modul.data.price_sum_net = (Helper.String(res.data.price_sum_net).length > 0) ? Helper.String(res.data.price_sum_net) : modul.data.price_sum_net;
                  modul.data.price_sum_gross = (Helper.String(res.data.price_sum_gross).length > 0) ? Helper.String(res.data.price_sum_gross) : modul.data.price_sum_gross;
                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      },
// getQueryTaxpayer
      getQueryTaxpayer: function (direction) {
        const modul = this;
        let arrTaxnumber = [];
        if (direction && direction === "from" && modul.data.from_taxnumber) {
          arrTaxnumber = modul.data.from_taxnumber.split("-");
        } else if (direction && direction === "to" && modul.data.to_taxnumber) {
          arrTaxnumber = modul.data.to_taxnumber.split("-");
        } else if (!direction || direction === "" && modul.data.taxnumber) {
          arrTaxnumber = modul.data.taxnumber.split("-");
        }
        if (!arrTaxnumber) {
          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorEmpty";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const taxnumber = arrTaxnumber[0];
        if (taxnumber && taxnumber.length !== 8) {

          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorFormat";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const data = {};
        data.taxNumber = taxnumber;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";

        Api.navGetDataByTaxnumber({data: data, id_company: modul.state.id_company}).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
//            modul.data = res.data;
            console.log(res.data)

            const data = Object.assign({}, res.data);

            if (direction && direction === "from") {
              const moduldata = Object.assign({}, modul.data);
//              moduldata.from_building = Helper.String(data.building); //
              moduldata.from_name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.from_nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"

              moduldata.from_taxnumber = Helper.String(data.taxnumber);

//              moduldata.from_city = Helper.String(data.city); // CSETÉNY"
//              moduldata.from_county = Helper.String(data.county); //
//              moduldata.from_door = Helper.String(data.door); //
//              moduldata.from_email_def = Helper.String(data.email_def); //
//              moduldata.from_floor = Helper.String(data.floor); //
//              moduldata.from_house_number = Helper.String(data.house_number); // 39"
////                            moduldata.id = Helper.String(data.id) ; //
//              moduldata.from_lot_number = Helper.String(data.lot_number); //
//              moduldata.from_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
//              moduldata.from_phone_def = Helper.String(data.phone_def); //
//              moduldata.from_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
//              moduldata.from_staircase = Helper.String(data.staircase); //
//              moduldata.from_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (direction && direction === "to") {
              const moduldata = Object.assign({}, modul.data);
//              moduldata.to_building = Helper.String(data.building); //
              moduldata.to_name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_taxnumber = Helper.String(data.taxnumber);
//              moduldata.to_city = Helper.String(data.city); // CSETÉNY"
//              moduldata.to_county = Helper.String(data.county); //
//              moduldata.to_door = Helper.String(data.door); //
//              moduldata.to_email_def = Helper.String(data.email_def); //
//              moduldata.to_floor = Helper.String(data.floor); //
//              moduldata.to_house_number = Helper.String(data.house_number); // 39"
////                            moduldata.id = Helper.String(data.id) ; //
//              moduldata.to_lot_number = Helper.String(data.lot_number); //
//              moduldata.to_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
//              moduldata.to_phone_def = Helper.String(data.phone_def); //
//              moduldata.to_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
//              moduldata.to_staircase = Helper.String(data.staircase); //
//              moduldata.to_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (!direction || direction === "") {
              const moduldata = Object.assign({}, modul.data);
//              moduldata.building = Helper.String(data.building); //
              moduldata.name = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.nameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
//              moduldata.city = Helper.String(data.city); // CSETÉNY"
//              moduldata.county = Helper.String(data.county); //
//              moduldata.door = Helper.String(data.door); //
//              moduldata.email_def = Helper.String(data.email_def); //
//              moduldata.floor = Helper.String(data.floor); //
//              moduldata.house_number = Helper.String(data.house_number); // 39"
////                            moduldata.id = Helper.String(data.id) ; //
//              moduldata.lot_number = Helper.String(data.lot_number); //
//              moduldata.nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
//              moduldata.phone_def = Helper.String(data.phone_def); //
//              moduldata.public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
//              moduldata.staircase = Helper.String(data.staircase); //
//              moduldata.zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            }


          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "";

        });
      },
      // getQueryTaxpayer
      getBusinessPartnerByTaxnumber: function () {
        const modul = this;
        modul.bank_account = "";
        const direction = "from";
        let arrTaxnumber = [];
        if (direction && direction === "from" && modul.data.from_taxnumber) {
          arrTaxnumber = modul.data.from_taxnumber.split("-");
        } else if (direction && direction === "to" && modul.data.to_taxnumber) {
          arrTaxnumber = modul.data.to_taxnumber.split("-");
        } else if (!direction || direction === "" && modul.data.taxnumber) {
          arrTaxnumber = modul.data.taxnumber.split("-");
        }
        if (!arrTaxnumber) {
          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorEmpty";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const taxnumber = arrTaxnumber[0];
        if (taxnumber && taxnumber.length !== 8) {

          modul.AlertInPage.msg = "BusinessPartner.taxPayerErrorFormat";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const data = {};
        data.taxnumber = taxnumber;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";

        Api.getBusinessPartnerByTaxnumber({data: data, id_company: modul.state.id_company}).then(function (res) {
          console.log(res);
          modul.bank_account = "";
          if (res && res.result && res.data) {

            console.log(res.data)
            const data = Object.assign({}, res.data);
            modul.bank_accountObject = {"bank_account": data.bank_account};
          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "";
          modul.bank_account = "";
        });
      },


//
      globalSetBusinessPartnerEventHandler: function (obj) {
        const modul = this;
        console.log("globalSetBusinessPartnerEventHandler")
        if (obj && obj.id) {
//          modul.businesspartnerid = obj.id;
//          modul.businesspartners.push(obj);
          modul.businesspartnerdata = obj;
          modul.businesspartnersearcher = false;
        }
      },


      businesspartnersearcherClick(){
        const modul = this;
        modul.businesspartnersearcher = true;
      },
      businesspartnersearcherClickClose(){
        const modul = this;
        modul.businesspartnersearcher = false;
      },

      fileUploadHadler(e){
        console.log("e");
        console.log(e);
      },
      imageClickHadler(e){
        console.log("e");
        console.log(e);
      },
      displayfn_from_taxnumber: function (value) {
        const modul = this;
        return Helper.displayfn_from_taxnumber(value);
      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      InputText,
      ImageDisplayer,
      FileUploader,
      MenuToggle,
      BusinessPartnerSearcher,
      NavDataDiffDisplayer,
      DataCheckerErrorDisplayer
    },
  };
</script>








